module.exports = __webpack_public_path__ + "static/videoBG.ad5b156b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/videoBG.jpg
// module id = 852
// module chunks = 21571696733600